import Account from "../../../../assets/Account";
import AccountType from "../../../../assets/AccountType";
import Banner from "../../../../assets/Banner";
import Client from "../../../../assets/Client";
import Dashboard from "../../../../assets/Dashboard";
import EmailTemplate from "../../../../assets/EmailTemplate";
import IbApproved from "../../../../assets/IbApproved";
import Kyc from "../../../../assets/Kyc";
import Task from "../../../../assets/Task";
import Tutorial from "../../../../assets/Tutorial";
import Disc from "../../../../assets/common/Disc";
import IbCommission from "../../../../assets/ibCommision/IbCommission";
import Support from "../../../../assets/support/Support";
import SystemSetting from "../../../../assets/systemSetting/SystemSetting";
import Wallet from "../../../../assets/wallet/Wallet";
import Promotion from "../../../../assets/Promotion.jsx";
import Reports from "../../../../assets/Reports.jsx";
import Sales from "../../../../assets/Sales.jsx";
import CashDeposit from "../../../../assets/CashDeposit.jsx";
import Analytics from "../../../../assets/Analytics.jsx";

export const SidebarData = [
  {
    title: "Dashboard",
    icon: <Dashboard />,
    url: "/dashboard",
    activeUrl: ["/dashboard"],
  },
  {
    title: "Analytics",
    icon: <Analytics />,
    url: "/analytics",
    activeUrl: ["/analytics"],
    forSales: false,
    module: "analytics",
  },
  {
    title: "Inbox",
    icon: <EmailTemplate />,
    url: "/inbox",
    activeUrl: ["/inbox"],
    forSales: false,
    module: "inbox",
  },
  {
    title: "Client",
    icon: <Client />,
    url: "/client",
    activeUrl: [
      "/client",
      "/client_details",
      "/account_details",
      "/parent_tree",
      "/ib_tree",
      "/mt5_account",
      ,
      "/deposit",
      "/deposit_usdt",
      "/withdraw",
      "/logs",
      "/live_account_details",
    ],
    forSales: true,
    module: "client",
  },
  {
    title: "Corporate review",
    icon: <Client />,
    url: "/corporate_review",
    activeUrl: ["/corporate_review"],
    forSales: true,
    module: "client",
  },
  {
    title: "Cash Deposit",
    icon: <CashDeposit />,
    activeUrl: ["/bank_details", "/deposit_request", "/usd_conversion"],
    module: "setting",
    children: [
      {
        title: "Bank Details",
        activeUrl: ["/bank_details"],
        icon: <Disc />,
        url: "/bank_details",
        module: "setting",
        subModule: "bank_detail",
      },
      // {
      //   title: "Deposit Request",
      //   activeUrl: ["/deposit_request"],
      //   icon: <Disc />,
      //   url: "/deposit_request",
      //   module: "wallet",
      //   subModule: "deposit",
      // },
      {
        title: "USD Conversion",
        activeUrl: ["/usd_conversion"],
        icon: <Disc />,
        url: "/usd_conversion",
        module: "setting",
        subModule: "conversion",
      },
    ],
    forSales: false,
  },
  {
    title: "KYC",
    icon: <Kyc />,
    url: "/kyc",
    activeUrl: ["/kyc"],
    forSales: true,
    module: "kyc",
  },
  {
    title: "Wallet",
    icon: <Wallet />,
    activeUrl: [
      "/wallet_withdraw",
      // "/wallet_deposit",
      "/wallet_internal_transfer",
      "/credit",
      "/deposit_request",
    ],
    module: "wallet",
    children: [
      // {
      //   title: "Deposit",
      //   icon: <Disc />,
      //   url: "/wallet_deposit",
      //   activeUrl: ["/wallet_deposit"],
      //   module: "wallet",
      //   subModule: "deposit",
      // },
      {
        title: "Deposit",
        activeUrl: ["/deposit_request"],
        icon: <Disc />,
        url: "/deposit_request",
        module: "wallet",
        subModule: "deposit",
      },
      {
        title: "Withdraw",
        icon: <Disc />,
        url: "/wallet_withdraw",
        activeUrl: ["/wallet_withdraw"],
        module: "wallet",
        subModule: "withdraw",
      },
      {
        title: "Credit",
        icon: <Disc />,
        url: "/credit",
        activeUrl: ["/credit"],
        module: "wallet",
        subModule: "credit",
      },
      {
        title: "Internal Transfer",
        icon: <Disc />,
        url: "/wallet_internal_transfer",
        activeUrl: ["/wallet_internal_transfer"],
        module: "wallet",
        subModule: "internal_transfer",
      },
    ],
    forSales: true,
  },
  {
    title: "Commission",
    icon: <IbCommission />,
    activeUrl: [
      "/ib_commission_generate",
      "/ib_commission_withdraw",
      "/ib_commission",
      "/ib_commission_reports",
    ],
    module: "commission",
    children: [
      {
        title: "Generate",
        url: "/ib_commission_generate",
        activeUrl: ["/ib_commission_generate", "/ib_commission"],
        icon: <Disc />,
        module: "commission",
        subModule: "comm_generate",
      },
      {
        title: "Withdraw",
        url: "/ib_commission_withdraw",
        activeUrl: ["/ib_commission_withdraw"],
        icon: <Disc />,
        module: "commission",
        subModule: "comm_withdraw",
      },
      {
        title: "Reports",
        url: "/ib_commission_reports",
        activeUrl: ["/ib_commission_reports"],
        icon: <Disc />,
        module: "commission",
        subModule: "comm_report",
      },
    ],
    forSales: true,
  },
  {
    title: "IB Manager",
    icon: <IbApproved />,
    url: "/ib_manager",
    activeUrl: ["/ib_manager", "/ib_details", "/ib_manager/ib_tree"],
    forSales: true,
    module: "ib_manager",
  },
  {
    title: "Accounts",
    icon: <Account />,
    url: "/accounts",
    activeUrl: ["/accounts", "/demo_accounts"],
    module: "account",
    children: [
      {
        title: "Live Accounts",
        icon: <Disc />,
        url: "/accounts",
        activeUrl: ["/accounts"],
        module: "account",
      },
      {
        title: "Demo Accounts",
        icon: <Disc />,
        url: "/demo_accounts",
        activeUrl: ["/demo_accounts"],
        module: "account",
      },
    ],
    forSales: true,
  },
  {
    title: "Sales",
    icon: <Sales />,
    activeUrl: [
      "/sales_dashboard",
      "/volume_report",
      "/office_goals_report",
      "/team_goals_report",
      "/ftd_report",
      "/source",
      "/leads",
    ],
    module: "sales",
    children: [
      {
        title: "Dashboard",
        icon: <Disc />,
        url: "/sales_dashboard",
        activeUrl: ["/sales_dashboard"],
        module: "sales",
        subModule: "dashboard",
      },
      {
        title: "Volume Report",
        icon: <Disc />,
        url: "/volume_report",
        activeUrl: ["/volume_report"],
        module: "sales",
        subModule: "volume_report",
      },
      {
        title: "Office Goals",
        icon: <Disc />,
        url: "/office_goals_report",
        activeUrl: ["/office_goals_report"],
        module: "sales",
        subModule: "office_goals",
      },
      {
        title: "Team Goals",
        icon: <Disc />,
        url: "/team_goals_report",
        activeUrl: ["/team_goals_report"],
        module: "sales",
        subModule: "team_goals",
      },
      {
        title: "FTD Report",
        icon: <Disc />,
        url: "/ftd_report",
        activeUrl: ["/ftd_report"],
        module: "sales",
        subModule: "ftd_report",
      },
      // {
      //   title: "Source",
      //   icon: <Disc />,
      //   url: "/source",
      //   activeUrl: ["/source"],
      //   module: MODULES.sales,
      //   subModule: MODULES.source,
      // },
      // {
      //   title: "Leads",
      //   icon: <Disc />,
      //   url: "/leads",
      //   activeUrl: ["/leads"],
      //   module: MODULES.sales,
      //   subModule: MODULES.leads,
      // },
    ],
  },
  {
    title: "Reports",
    icon: <Reports />,
    activeUrl: [
      "/wallet_withdraw",
      "/wallet_deposit",
      "/wallet_internal_transfer",
      "/wallet_report",
      "/ib_commission_generate",
      "/commission_data",
    ],
    module: "report",
    children: [
      {
        title: "Deposit",
        icon: <Disc />,
        url: "/wallet_deposit",
        activeUrl: ["/wallet_deposit"],
        module: "wallet",
        subModule: "deposit",
      },
      {
        title: "Withdraw",
        icon: <Disc />,
        url: "/wallet_withdraw",
        activeUrl: ["/wallet_withdraw"],
        module: "wallet",
        subModule: "withdraw",
      },
      {
        title: "Internal Transfer",
        icon: <Disc />,
        url: "/wallet_internal_transfer",
        activeUrl: ["/wallet_internal_transfer"],
        module: "wallet",
        subModule: "internal_transfer",
      },
      {
        title: "Wallet Report",
        icon: <Disc />,
        url: "/wallet_report",
        activeUrl: ["/wallet_report"],
        module: "report",
      },
      {
        title: "IB Commission",
        icon: <Disc />,
        url: "/ib_commission_generate",
        activeUrl: ["/ib_commission_generate"],
        module: "commission",
        subModule: "comm_generate",
      },
      {
        title: "Threshold",
        icon: <Disc />,
        url: "/thres_hold_reports",
        activeUrl: ["/thres_hold_reports"],
        module: "report",
      },
      {
        title: "T&C",
        icon: <Disc />,
        url: "/terms_report",
        activeUrl: ["/terms_report"],
        module: "report",
      },
    ],
    forSales: true,
  },
  {
    title: "Banner",
    icon: <Banner />,
    url: "/banner",
    activeUrl: ["/banner"],
    forSales: false,
    module: "banner",
  },
  {
    title: "Sub Admins",
    icon: <Client />,
    url: "/sub_admin",
    activeUrl: ["/sub_admin", "/assigned_to_sales"],
    forSales: false,
    module: "subadmin",
  },
  {
    title: "Support",
    icon: <Support />,
    activeUrl: ["/ticket", "/view_ticket", "/faq"],
    module: "support",
    children: [
      {
        title: "Ticket",
        activeUrl: ["/ticket", "/view_ticket"],
        icon: <Disc />,
        url: "/ticket",
        module: "support",
        subModule: "ticket",
      },
      {
        title: "FAQ",
        activeUrl: ["/faq"],
        icon: <Disc />,
        url: "/faq",
        module: "support",
        subModule: "faq",
      },
    ],
    forSales: false,
  },
  {
    title: "Tutorial",
    icon: <Tutorial />,
    url: "/tutorial",
    activeUrl: ["/tutorial"],
    forSales: false,
    module: "tutorial",
  },
  {
    title: "Email Template",
    icon: <EmailTemplate />,
    url: "/email_template",
    activeUrl: [
      "/email_template",
      "/add_email_template",
      "/edit_email_template",
    ],
    forSales: true,
    module: "email_template",
  },
  {
    title: "Email marketing ",
    icon: <EmailTemplate />,
    url: "/email_marketing",
    activeUrl: ["/email_marketing", "/email_marketing/:id"],
    forSales: false,
    module: "email_marketing",
  },
  {
    title: "Account Type",
    icon: <AccountType />,
    url: "/account_Type",
    activeUrl: ["/account_Type"],
    forSales: false,
    module: "account_type",
  },
  {
    title: "Log",
    icon: <Task />,
    url: "/log",
    activeUrl: ["/log"],
    forSales: true,
  },
  {
    title: "Settings",
    icon: <SystemSetting />,
    activeUrl: [
      "/notifications",
      "/kyc_Rules",
      "/roles",
      "/rules",
      "/reminder",
      "/payment_Gateway",
      "/assign_Rules",
      "payment_Gateway",
      "kyc_Rules",
      "group_Symbols",
      "/teams",
      "/sales_office",
    ],
    module: "setting",
    children: [
      {
        title: "Sales Office",
        icon: <Disc />,
        url: "/sales_office",
        activeUrl: ["/sales_office"],
        module: "setting",
        subModule: "sales_office",
      },
      {
        title: "T&C",
        icon: <Disc />,
        url: "/terms",
        activeUrl: ["/terms", "/add_terms"],
        module: "setting",
        subModule: "tnc",
      },
      {
        title: "Notifications",
        icon: <Disc />,
        url: "/notifications",
        activeUrl: ["/notifications"],
        module: "setting",
        subModule: "notification",
      },
      {
        title: "KYC Rules",
        icon: <Disc />,
        url: "/kyc_Rules",
        activeUrl: ["/kyc_Rules"],
        module: "setting",
      },
      {
        title: "Rules",
        icon: <Disc />,
        url: "/rules",
        activeUrl: ["/rules"],
        module: "setting",
        subModule: "rules",
      },
      {
        title: "Reminder",
        icon: <Disc />,
        url: "/reminder",
        activeUrl: ["/reminder"],
        module: "setting",
      },
      {
        title: "PSP",
        url: "/payment_Gateway",
        activeUrl: ["/payment_Gateway"],
        icon: <Disc />,
        module: "setting",
        subModule: "psp",
      },
      {
        title: "Symbol",
        url: "/symbol",
        activeUrl: ["/symbol"],
        icon: <Disc />,
        module: "setting",
        subModule: "symbol",
      },
      {
        title: "Threshold",
        url: "/thres_hold",
        activeUrl: ["/thres_hold"],
        icon: <Disc />,
        module: "setting",
        subModule: "threshold",
      },
    ],
    forSales: false,
  },
];

export const getSidebarDataForUser = (department) => {
  let data = SidebarData;

  if (department === "Sales") {
    data = data.map((menuItem) => {
      if (menuItem?.title !== "Sales" || !Array.isArray(menuItem.children)) {
        return menuItem;
      }
      return {
        ...menuItem,
        children: menuItem.children.filter(
          (child) => child.url !== "/sales_dashboard",
        ),
      };
    });
  }

  return data;
};
